import React from "react";
import styles from "./Details.module.css";
import { Button } from "../../../common/Button";
import { ButtonFooter } from "../../../common/ButtonFooter";

interface OptionsProps {
  instructions?: string;
  onPaid: () => void;
}

export const Instructions = ({ instructions, onPaid }: OptionsProps) => {
  return (
    <div className={styles.container}>
      <form>
        <div>{instructions}</div>

        <ButtonFooter showNote>
          <Button
            type="button"
            text="I have paid"
            buttonStyle="primary"
            onClick={onPaid}
          />
        </ButtonFooter>
      </form>
    </div>
  );
};
